import { render, staticRenderFns } from "./view.vue?vue&type=template&id=2462cc0a&scoped=true"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2462cc0a",
  null
  
)

export default component.exports